var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    width: 125,
    height: 75,
    viewBox: "0 0 125 75",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_2_G_D_0_P_0",
    fill: "freeze",
    attributeName: "fill",
    from: "#ff0000",
    to: "#ff0000",
    keyTimes: "0;0.1846154;0.3692308;1",
    values: "#ff0000;#b70000;#ff0000;#ff0000",
    keySplines: "0.167 0 0.667 1;0.333 0 0.833 0.999;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_2_G",
    fill: "freeze",
    keyTimes: "0;0.1846154;0.3692308;1",
    path: "M56.5 44 C56.5,40.67 56.5,24 56.5,24 C56.5,24 56.5,40.67 56.5,44 C56.5,44 56.5,44 56.5,44 ",
    keyPoints: "0;0.5;1;1",
    keySplines: "0.333 0 0.4 1;0.333 0 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "7.64558 7.64558",
    to: "7.64558 7.64558",
    type: "scale",
    additive: "sum",
    keyTimes: "0;1",
    values: "7.64558 7.64558;7.64558 7.64558",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_2_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-12.5 -6",
    to: "-12.5 -6",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-12.5 -6;-12.5 -6",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_1_G_D_0_P_0",
    fill: "freeze",
    attributeName: "fill",
    from: "#ff0000",
    to: "#ff0000",
    keyTimes: "0;0.0769231;0.2615385;0.4461538;1",
    values: "#ff0000;#ff0000;#b70000;#ff0000;#ff0000",
    keySplines: "0.167 0 0.667 1;0.167 0 0.667 1;0.333 0 0.833 0.999;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_1_G",
    fill: "freeze",
    keyTimes: "0;0.0769231;0.2615385;0.4461538;1",
    path: "M56.5 44 C56.5,44 56.5,44 56.5,44 C56.5,40.67 56.5,24 56.5,24 C56.5,24 56.5,40.67 56.5,44 C56.5,44 56.5,44 56.5,44 ",
    keyPoints: "0;0;0.5;1;1",
    keySplines: "0.333 0 0.4 1;0.333 0 0.4 1;0.333 0 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "7.64558 7.64558",
    to: "7.64558 7.64558",
    type: "scale",
    additive: "sum",
    keyTimes: "0;1",
    values: "7.64558 7.64558;7.64558 7.64558",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_1_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-12.5 -6",
    to: "-12.5 -6",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-12.5 -6;-12.5 -6",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_0_G_D_0_P_0",
    fill: "freeze",
    attributeName: "fill",
    from: "#ff0000",
    to: "#ff0000",
    keyTimes: "0;0.1538462;0.3384615;0.5230769;1",
    values: "#ff0000;#ff0000;#b70000;#ff0000;#ff0000",
    keySplines: "0.167 0 0.833 1;0.167 0 0.833 1;0.167 0.001 0.833 0.999;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_0_G",
    fill: "freeze",
    keyTimes: "0;0.1538462;0.3384615;0.5230769;1",
    path: "M56.5 44 C56.5,44 56.5,44 56.5,44 C56.5,40.67 56.5,24 56.5,24 C56.5,24 56.5,40.67 56.5,44 C56.5,44 56.5,44 56.5,44 ",
    keyPoints: "0;0;0.5;1;1",
    keySplines: "0.333 0 0.4 1;0.333 0 0.4 1;0.333 0 0.4 1;0 0 0 0",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: "7.64558 7.64558",
    to: "7.64558 7.64558",
    type: "scale",
    additive: "sum",
    keyTimes: "0;1",
    values: "7.64558 7.64558;7.64558 7.64558",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.0833333s",
    begin: "0s",
    xlinkHref: "#_R_G_L_0_G_L_0_G",
    fill: "freeze",
    attributeName: "transform",
    from: "-12.5 -6",
    to: "-12.5 -6",
    type: "translate",
    additive: "sum",
    keyTimes: "0;1",
    values: "-12.5 -6;-12.5 -6",
    keySplines: "0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "opacity",
    dur: "1s",
    from: 0,
    to: 1,
    xlinkHref: "#time_group"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_R_G"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G",
    transform: " translate(70.5, 43.5) translate(-62.5, -50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G_L_2_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_L_2_G_D_0_P_0",
    fill: "#ff0000",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M8.5 5.83 C8.5,6.66 7.83,7.33 7,7.33 C6.17,7.33 5.5,6.66 5.5,5.83 C5.5,5.01 6.17,4.33 7,4.33 C7.83,4.33 8.5,5.01 8.5,5.83z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G_L_1_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_L_1_G_D_0_P_0",
    fill: "#ff0000",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M13.83 5.83 C13.83,6.66 13.16,7.33 12.33,7.33 C11.51,7.33 10.83,6.66 10.83,5.83 C10.83,5.01 11.51,4.33 12.33,4.33 C13.16,4.33 13.83,5.01 13.83,5.83z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_R_G_L_0_G_L_0_G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_R_G_L_0_G_L_0_G_D_0_P_0",
    fill: "#ff0000",
    fillOpacity: 1,
    fillRule: "nonzero",
    d: " M19.17 5.83 C19.17,6.66 18.5,7.33 17.67,7.33 C16.84,7.33 16.17,6.66 16.17,5.83 C16.17,5.01 16.84,4.33 17.67,4.33 C18.5,4.33 19.17,5.01 19.17,5.83z "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "time_group"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.17ddf6f074af64d94849adc21638dc2a.svg";
export { ForwardRef as ReactComponent };